var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '../../dom';
import './Button.less';
var Button = /** @class */ (function (_super) {
    __extends(Button, _super);
    function Button(props, content) {
        var _this = _super.call(this, props) || this;
        _this.name = 'Button';
        _this.onClick = function (e) {
            if (_this.el.hasClassName('Button_ajaxLoader'))
                return;
            _this.props.onClick(e);
        };
        var rootClassName = _this.constructor.rootClassName;
        if (props.className) {
            props.className += " ".concat(rootClassName);
        }
        else {
            props.className = rootClassName;
        }
        _this.el = _this.DIV(props, content);
        return _this;
    }
    Button.prototype.toggleAjaxLoader = function (force) {
        var _this = this;
        if (force) {
            this.el.toggleClassName('Button_ajaxLoader', force);
        }
        else {
            setTimeout(function () { return _this.el.toggleClassName('Button_ajaxLoader', force); }, 250); // TODO
        }
    };
    Object.defineProperty(Button.prototype, "html", {
        set: function (html) {
            ;
            this.el.html(html);
        },
        enumerable: false,
        configurable: true
    });
    Button.prototype.className = function () {
        return this.props.className ? "Button ".concat(this.props.className) : 'Button';
    };
    Button.rootClassName = '&';
    return Button;
}(Component));
export { Button };
var BlueButton = /** @class */ (function (_super) {
    __extends(BlueButton, _super);
    function BlueButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BlueButton.rootClassName = '& &_blue';
    return BlueButton;
}(Button));
export { BlueButton };
var GreenButton = /** @class */ (function (_super) {
    __extends(GreenButton, _super);
    function GreenButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GreenButton.rootClassName = '& &_green';
    return GreenButton;
}(Button));
export { GreenButton };
var OrangeButton = /** @class */ (function (_super) {
    __extends(OrangeButton, _super);
    function OrangeButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrangeButton.rootClassName = '& &_orange';
    return OrangeButton;
}(Button));
export { OrangeButton };
